<template>
<div>
  <!-- Tabs 标签页：普通异常 + 骑行超速 -->
  <el-tabs v-model="activeTab" type="card" class="mb20" @tab-click="handleTabClick">
    <!-- 1. 原普通异常告警 -->
    <el-tab-pane label="普通异常告警" name="normal">
  <div class="layout-header" ref="warningLayoutHeader">
    <div class="infor-layout-header mb20">
      <span class="title">异常告警历史详情
        <span @mouseenter="showWarningText = !showWarningText" @mouseleave="showWarningText = !showWarningText" class="showWarningText">(查看警告类型)</span>
      </span>
      <p style="margin-right: 0.625rem">
        <el-button type="danger" size="small" @click="closeHistory">关闭</el-button>
      </p>
    </div>
    <el-row type="flex" class="row-bg abh row-bg-self" justify="space-between">
      <el-col :span="24">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="品牌名称：">
            <el-select class="w120px" v-model="formInline.brandId" :size="size" placeholder="">
              <el-option :label="item.brandName" :value="item.brandId" v-for="item in companyDataWithAll" :key="'company'+item.brandId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆编号">
            <el-input class="w120px" v-model="formInline.bikeId" :size="size" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="车辆类型：">
            <el-select class="w120px" v-model="formInline.bikeType" :size="size" placeholder="" :disabled="disabled">
              <el-option :label="item.label" :value="item.value" v-for="item in bikeTypeList" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="warning-show" label="警告类型：">
            <el-select class="w120px" v-model="formInline.abnormalType" :size="size" placeholder="">
              <el-option :label="item.label" :value="item.key" v-for="item in abnormalTypes" :key="'types'+item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间：">
            <el-date-picker class="w250px" :size="size" v-model="formInline.updateTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="onSearch" type="primary" :size="size" style="background-color: #3e7878;border-color: #3e7878">查询</el-button>
            <el-button @click="onReset" :size="size">重置</el-button>
            <el-button v-show="checkUserAuth(7, 10)" @click="onExport" :size="size">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div class="warning-text" v-show="showWarningText">
      <p class="mb3">警告类型说明：</p>
      <p>站外还车 ：共享单车企业上传的还车数据出现没有站点编号或站点编号不在平台数据库；</p>
      <p>违法设备 ：共享单车企业上传的还车数据有站点编号,且站点编号为蓝牙站点,上传的MAC地址不在库里；</p>
      <p>超时未还 ：传来租车数据后长时间（超过24小时）没有还车记录的；</p>
      <p>异常站点 ：某个站点持续48小时以上没有租还数据的；</p>
      <p>故障车辆 ：某个车超过96小时没有人租还的；</p>
      <p>满桩还车 ：违反满桩禁停还车；</p>
      <p>非法车辆 ：未经政府审批违规投放的车辆；</p>
      <p>还车异常 ：出现出租状态上架、出租状态下架、出租状态出租；</p>
      <p>租车异常 ：出现还车状态归还、上架状态还车；</p>
      <p>下架异常 ：出现还车状态上架、上架状态上架；</p>
      <p>上架异常 ：出现下架状态出租、下架状态还车、下架状态下架；</p>
      <p>站外投车 ：车辆调度上架时企业上传的上架数据中出现没有站点编号或站点编号不在平台数据库；</p>
      <p>超区停放 ：超过系统设定的大区域范围内停放的车辆。</p>
    </div>
  </div>
  <div style="height:19.0625rem;" v-show="showWarningText"></div>
  <div style="height:8.875rem;" v-show="!showWarningText"></div>
  <div class="m16 pagination-bg-white table-container" style="padding: 0;">
    <w-table ref="abnormalTable" :height="tableViewHeight" v-loading.body="tableLoading" :data-list="abnormalData" :columns="staticData.columns" :pageNo="formData.pageNum" :pageSize="formData.pageSize" :total="total" :pageSizes="[50,100,200]" @pageNoChange="pageNoChange" @pageSizeChange="pageSizeChange" @update="updatePageNum">
      <template v-slot:cell="props">
        <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize}}</span>
        <span v-else-if="props.column.label === '告警时间'">
          {{ props.row['updateTime'] | dateFormat('yyyy-MM-dd hh:mm:ss')}}
        </span>
        <span v-else-if="props.column.label === '告警类型'">
          <span :class="{
                'red': props.row['abnormalType'] === '1',
                'origin': props.row['abnormalType'] === '2',
                'warning': props.row['abnormalType'] === '3',
                'green': props.row['abnormalType'] === '4',
                'blue': props.row['abnormalType'] === '5',
                'pink': props.row['abnormalType'] === '6',
              }">
            {{ getAbnormalType(props.row['abnormalType'])}}
          </span>
        </span>
        <span v-else-if="props.column.label === '品牌名称'">
          {{ props.row['brandName']}}
        </span>
        <span v-else-if="props.column.label === '车辆编号'">
          {{ props.row['bikeId']}}
        </span>

        <span v-else-if="props.column.label === '车辆类型'">
          {{ getBikeType(props.row['bikeType'])}}
        </span>
        <span v-else-if="props.column.label === '告警地点'">
          <span @click="jjSearch(props.row)" class="cursor text-decoration" style="display:block;">{{ getShowText(props.row) }}</span>
        </span>
        <span v-else>{{ props.row[props.column.property]}}</span>
      </template>
    </w-table>
  </div>
    </el-tab-pane>
    <!-- 2. 新增：骑行超速告警 -->
    <el-tab-pane label="骑行超速告警" name="overSpeed" v-if="checkUserAuth(7, 251)">
      <div class="layout-header" ref="rideLayoutHeader">
        <div class="infor-layout-header mb20">
          <span class="title">骑行超速告警历史</span>
          <p style="margin-right: 0.625rem">
            <el-button type="danger" size="small" @click="closeHistory">关闭</el-button>
          </p>
        </div>
        <el-row type="flex" class="row-bg abh row-bg-self" justify="space-between">
          <el-col :span="24">
            <el-form :inline="true" :model="overspeedForm" class="demo-form-inline">
              <el-form-item label="品牌名称：">
                <el-select class="w120px" v-model="overspeedForm.brandId" size="small" placeholder="">
                  <el-option
                    :label="item.brandName"
                    :value="item.brandId"
                    v-for="item in companyDataWithAll"
                    :key="'os_'+item.brandId"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="车辆编号">
                <el-input class="w120px" v-model="overspeedForm.bikeId" size="small" placeholder="" />
              </el-form-item>
              <el-form-item label="车辆类型：">
                <el-select class="w120px" v-model="overspeedForm.bikeType" size="small" placeholder="" :disabled="overspeedForm.disabled">
                  <el-option :label="item.label" :value="item.value" v-for="item in bikeTypeList" :key="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单号">
                <el-input class="w160px" v-model="overspeedForm.orderNo" size="small" placeholder="" />
              </el-form-item>
              <el-form-item label="创建时间：">
                <el-date-picker
                  class="w250px"
                  size="small"
                  v-model="overspeedForm.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                />
              </el-form-item>
              <el-form-item>
                <el-button @click="onOverSpeedSearch" type="primary" size="small" style="background-color: #3e7878;border-color: #3e7878">查询</el-button>
                <el-button @click="onOverSpeedReset" size="small">重置</el-button>
                <el-button v-show="checkUserAuth(7, 252)" @click="onOverSpeedExport" size="small">导出</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <div class="setting-container" v-if="aggregation === 1">
            <label>用户骑行超速阈值设置:</label>
            <el-input-number
              v-model="speedLimit"
              size="small"
              :precision="2"
              controls-position="right"
              :step="0.1"
              :min="1"
              :max="99"/>
            <span class="time-unit">km/h</span>
            <el-button
              @click="saveSpeedLimit"
              v-show="checkUserAuth(7, 253)"
              type="primary"
              size="small"
              style="background-color:#3e7878;border-color:#3e7878">
              保存
            </el-button>
          </div>
        </el-row>
      </div>
      <div style="height:8.875rem;"></div>
      <div class="m16 pagination-bg-white table-container" style="padding:0;">
        <el-table
          v-show="checkUserAuth(4, 236)"
          v-loading.body="tableLoading"
          :data="overSpeedData"
          :height="rideTableViewHeight"
          width="100%"
          highlight-current-row>
          <el-table-column prop="index" label="序号" align="center" width="60">
            <template v-slot="props">
              <span>{{ props.$index + 1 + (formData.pageNum - 1) * formData.pageSize }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="brandName" label="品牌名称" align="center"/>
          <el-table-column prop="orderNo" label="订单号" width="180" align="center"/>
          <el-table-column prop="userId" label="用户编号" width="180" align="center"/>
          <el-table-column prop="bikeId" label="车辆编号" align="center"/>
          <el-table-column prop="bikeType" label="车辆类型" align="center">
            <template v-slot="props">
              {{ getBikeType(props.row['bikeType'])}}
            </template>
          </el-table-column>
          <el-table-column prop="abnormalType" label="告警类型" align="center">
            <template v-slot="props">
                <span :class="{
                'red': props.row['abnormalType'] === '1'
              }">
            {{ getOverSpeedType(props.row['abnormalType'])}}
          </span>
            </template>
          </el-table-column>
          <el-table-column prop="speedLimit" label="限速阈值" align="center">
            <template v-slot="props">
              <span>{{props.row.speedLimit}} km/h</span>
            </template>
          </el-table-column>
          <el-table-column prop="maxSpeed" label="最高速度" align="center">
            <template v-slot="props">
              <span>{{props.row.maxSpeed}} km/h</span>
            </template>
          </el-table-column>
          <el-table-column prop="maxSpeed" label="平均速度" align="center">
            <template v-slot="props">
              <span>{{props.row.avgSpeed}} km/h</span>
            </template>
          </el-table-column>
          <el-table-column prop="speedLimit" label="限速阈值" align="center">
            <template v-slot="props">
              <span>{{props.row.speedLimit}}  km/h</span>
            </template>
          </el-table-column>
          <el-table-column prop="duration" label="超速时长" align="center">
            <template v-slot="props">
              <span>{{ formatDuration(props.row.duration) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="超速开始时间" sortable width="180">
            <template v-slot="props">
              <span>{{props.row.startTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="endTime" label="超速结束时间" sortable width="180">
            <template v-slot="props">
              <span>{{props.row.endTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" sortable width="180">
            <template v-slot="props">
              <span>{{props.row.createTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px;padding-bottom: 10px; text-align: right"
          @size-change="overSpeedHandleSizeChange"
          @current-change="overSpeedPageNoChange"
          :current-page="overSpeedPage.pageNum"
          :page-sizes="overSpeedPageSizes"
          :page-size="overSpeedPage.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="overSpeedTotal">
        </el-pagination>
      </div>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import WTable from '@/components/Table/index.vue'
import Api from '@/api'
import {
  dateFormat,
  getFilterParams,
  lookPDF
} from '@/utils/tools'
import staticData from './staticData.js'
import {
  Loading
} from 'element-ui'
import util from '@/assets/js/util'
import dayjs from 'dayjs'
export default {
  props: ['companyData'],
  data() {
    return {
      // Tab 切换
      activeTab: 'normal',
      size: 'small',
      // 原普通告警
      formInline: {
        brandId: '',
        bikeId: '',
        abnormalType: '',
        bikeType: '',
        updateTime: [dateFormat(new Date().setDate(new Date().getDate()), 'yyyy-MM-dd'), dateFormat(new Date(), 'yyyy-MM-dd')]
      },
      abnormalTypes: [
        { label: '全部', key: '' },
        { label: '非法车辆', key: 7 },
        { label: '站外还车', key: 1 },
        { label: '故障车辆', key: 5 },
        { label: '满桩还车', key: 6 },
        { label: '异常站点', key: 4 },
        { label: '超时未还', key: 3 },
        { label: '违法设备', key: 2 },
        { label: '不可投放站点上架', key: 8 },
        { label: '还车异常', key: 9 },
        { label: '租车异常', key: 10 },
        { label: '上架异常', key: 11 },
        { label: '下架异常', key: 12 },
        { label: '站外投车', key: 13 },
        { label: '超区停放', key: 14 }
      ],
      tableLoading: false,
      abnormalData: [],
      total: 0,
      formData: {
        pageNum: 1,
        pageSize: 50
      },
      // 0-自行车，1-电动车
      bikeTypeList: [
        { value: '', label: '全部' },
        { value: 0, label: '自行车' },
        { value: 1, label: '电动车' }
      ],
      tableViewHeight: '',
      showWarningText: false,
      historyAbnormalData: [],
      historyAbnormalTotal: 0,
      disabled: true,
      // ================== 骑行超速告警（新增） ==================
      rideTableViewHeight: 50,
      overspeedForm: {
        brandId: '',
        bikeId: '',
        orderNo: '',
        createTime: [
          dateFormat(new Date().setDate(new Date().getDate()), 'yyyy-MM-dd'),
          dateFormat(new Date(), 'yyyy-MM-dd')
        ],
        bikeType: '',
        disabled: true
      },
      overspeedLoading: false,
      overSpeedData: [], // 超速告警数据
      overSpeedTotal: 0,
      overSpeedPage: {
        pageNum: 1,
        pageSize: 50
      },
      overSpeedPageSizes: [10, 20, 50],
      speedLimit: undefined, // 设置用户骑行超速阈值
      speedLimitData: {}
    }
  },
  computed: {
    ...mapGetters([
      'currpath',
      'user',
      'globaleSelfAreaId',
      'siteMessage',
      'selfAreaId',
      'brands',
      'userSelectAddressData',
      'userBikeType']),
    staticData() {
      return staticData
    },
    companyDataWithAll() {
      const arr = JSON.parse(JSON.stringify(this.brands || []))
      arr.unshift({ brandName: '全部', brandId: '' })
      return arr
    },
    aggregation() {
      // 0 - 实体区 1复合区
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregation
        : undefined
    }
  },
  mounted() {
    util.$emit('event', true)
    this.calcView()
    window.addEventListener('resize', this.handleResize)
  },
  watch: {
    activeTab(newVal) {
      this.$nextTick(() => {
        if (newVal === 'normal') {
          const height = this.$refs.warningLayoutHeader?.clientHeight || 0
          this.tableViewHeight = window.innerHeight - height - 180
        } else if (newVal === 'overSpeed') {
          const height = this.$refs.rideLayoutHeader?.clientHeight || 0
          this.rideTableViewHeight = window.innerHeight - height - 180
          this.getRideSpeedLimitConfig()
        }
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  created() {
    if (this.userBikeType === 2) {
      this.formInline.bikeType = ''
      this.disabled = false
      this.overspeedForm.bikeType = ''
      this.overspeedForm.disabled = false
    } else {
      this.formInline.bikeType = this.userBikeType
      this.disabled = true
      this.overspeedForm.bikeType = this.userBikeType
      this.overspeedForm.disabled = true
    }
    if (!this.$parent.abnormalFlag) {
      this.initData()
    }
  },
  methods: {
    // 计划视图区域
    calcView() {
      this.$nextTick(() => {
        if (this.activeTab === 'normal') {
          const height = this.$refs.warningLayoutHeader?.clientHeight || 0
          this.tableViewHeight = window.innerHeight - height - 180
        } else if (this.activeTab === 'overSpeed') {
          const height = this.$refs.rideLayoutHeader?.clientHeight || 0
          this.rideTableViewHeight = window.innerHeight - height - 180
        }
      })
    },
    handleResize() {
      this.$nextTick(() => {
        if (this.activeTab === 'normal') {
          const height = this.$refs.warningLayoutHeader?.clientHeight || 0
          this.tableViewHeight = window.innerHeight - height - 180
        } else if (this.activeTab === 'overSpeed') {
          const height = this.$refs.rideLayoutHeader?.clientHeight || 0
          this.rideTableViewHeight = window.innerHeight - height - 180
        }
      })
    },
    handleTabClick(tab, event) {
      if (tab === 'normal') {
        this.onSearch()
      } else {
        this.onOverSpeedSearch()
      }
    },
    getShowText(item) {
      if (item.siteName) return item.siteName
      if (item.lon && item.lat) return `经度：${item.lon}，纬度：${item.lat}`
      return '-'
    },
    closeHistory() {
      this.$emit('closeHistory')
    },
    jjSearch(item) {
      // 传值
      util.$emit('event', false)
      const vm = this
      localStorage.setItem('selectCurrentLineData', JSON.stringify(item))
      // 满装还车-6，异常站点-4，跳转对应站点
      if (['6', '4', '8'].includes(item.abnormalType) && item.siteId) {
        const loadingInstance = Loading.service({
          fullscreen: true,
          text: '站点搜索中...'
        })
        vm.closeHistory()
        loadingInstance.close()
        setTimeout(() => {
          vm.$router.push('/dailyDuty' + (vm.currpath.split('/')[2] ? ('/' + vm.currpath.split('/')[2]) : '') + '?siteId=' + item.siteId)
        }, 0)
      } else if (item.bikeId) {
        const loadingInstance = Loading.service({
          fullscreen: true,
          text: '站点搜索中...'
        })
        vm.closeHistory()
        loadingInstance.close()
        setTimeout(() => {
          console.log('dailyDuty')
          vm.$router.push('/dailyDuty' + (vm.currpath.split('/')[2] ? ('/' + vm.currpath.split('/')[2]) : '') + '?bikeId=' + item.bikeId)
        }, 0)
      } else {
        vm.$message.warning('该条数据存在问题，没有车辆编号！')
      }
    },
    initData() {
      const vm = this
      vm.tableLoading = true
      let params = {
        selfAreaId: vm.selfAreaId,
        currentPage: vm.formData.pageNum,
        pageSize: vm.formData.pageSize,
        bikeType: vm.formInline.bikeType
      }
      if (vm.formInline.updateTime && vm.formInline.updateTime[0] && vm.formInline.updateTime[1]) {
        params.startTime = new Date(vm.formInline.updateTime[0]).getTime()
        params.endTime = new Date(vm.formInline.updateTime[1]).getTime() + (23 * 60 * 60 + 59 * 60 + 59) * 1000
      }
      if (vm.formInline.brandId || Number(vm.formInline.brandId) === 0) {
        params.brandId = vm.formInline.brandId
      }
      if (vm.formInline.abnormalType || Number(vm.formInline.abnormalType) === 0) {
        params.abnormalType = vm.formInline.abnormalType
      }
      if (vm.formInline.bikeId || Number(vm.formInline.bikeId) === 0) {
        params.bikeId = vm.formInline.bikeId
      }
      params = getFilterParams(params)
      Api.getMsg(params)
        .then(res => {
          if (res.code === 200) {
            vm.abnormalData = res.data.lists
            vm.total = res.data.total
            vm.translate()
            // 存
            // 将this.pickerItem的数据存储入insuranceCode,需提前转化成string类型
            localStorage.setItem('historyAbnormalTotal', vm.total)
            localStorage.setItem('historyAbnormalPageNum', vm.formData.pageNum)
            localStorage.setItem('historyAbnormalData', JSON.stringify(vm.abnormalData))
          } else {
            vm.$message.warning(res.message)
          }
          vm.calcView()
          vm.tableLoading = false
        })
    },
    // 刷新页面或者从别的页面进入，提取this.history的值
    getAbnormalData() {
      // 取
      const vm = this
      // 获取localStorage数组数据
      vm.abnormalData = JSON.parse(localStorage.getItem('historyAbnormalData'))
      vm.total = parseInt(localStorage.getItem('historyAbnormalTotal'))
      const pageNum = parseInt(localStorage.getItem('historyAbnormalPageNum'))
      vm.translate()
      vm.$refs.abnormalTable.setCurrentTwo(JSON.parse(localStorage.getItem('selectCurrentLineData')), vm.abnormalData, pageNum)
    },
    translate() {
      const vm = this
      if (vm.abnormalData && vm.abnormalData.length) {
        vm.abnormalData.forEach(item => {
          if (vm.companyData && vm.companyData.find(it => Number(it.brandId) === Number(item.brandId))) {
            const brandName = vm.companyData.find(it => Number(it.brandId) === Number(item.brandId)).brandName
            vm.$set(item, 'brandName', brandName)
          }
        })
      }
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.initData()
    },
    // 点击告警地点后返回异常告警表格数据，定位之前选中的告警地点行并进行高亮显示
    updatePageNum(newPageNum) {
      this.formData.pageNum = newPageNum // 更新父组件的
    },
    pageSizeChange(size) {
      this.formData.pageSize = size
      this.initData()
    },
    onSearch() {
      // 默认分页为1
      this.formData.pageNum = 1
      this.initData()
    },
    onReset() {
      this.formInline.brandId = ''
      this.formInline.bikeId = ''
      this.formInline.abnormalType = ''
      this.formInline.updateTime = ''
      this.formInline.bikeType = ''
      this.onSearch()
    },
    onExport() {
      const vm = this
      let params = {
        selfAreaId: vm.selfAreaId,
        bikeType: vm.formInline.bikeType
      }
      if (vm.formInline.updateTime && vm.formInline.updateTime[0] && vm.formInline.updateTime[1]) {
        params.startTime = new Date(vm.formInline.updateTime[0]).getTime()
        params.endTime = new Date(vm.formInline.updateTime[1]).getTime() + (23 * 60 * 60 + 59 * 60 + 59) * 1000
      }
      if (vm.formInline.brandId || Number(vm.formInline.brandId) === 0) {
        params.brandId = vm.formInline.brandId
      }
      if (vm.formInline.abnormalType || Number(vm.formInline.abnormalType) === 0) {
        params.abnormalType = vm.formInline.abnormalType
      }
      if (vm.formInline.bikeId || Number(vm.formInline.bikeId) === 0) {
        params.bikeId = vm.formInline.bikeId
      }
      params = getFilterParams(params)
      Api.exportMsg(params)
        .then(res => {
          if (res.code === 200) {
            lookPDF(res.data)
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    getAbnormalType(t) {
      const map = {
        1: '站外还车',
        2: '违法设备',
        3: '超时未还',
        4: '异常站点',
        5: '故障车辆',
        6: '满桩还车',
        7: '非法车辆',
        8: '不可投放站点上架',
        9: '还车异常',
        10: '租车异常',
        11: '上架异常',
        12: '下架异常',
        13: '站外投车',
        14: '超区停放'
      }
      return map[String(t)] || '-'
    },
    getBikeType(t) {
      return {
        0: '自行车',
        1: '电动车'
      }[String(t)] || '-'
    },
    // ================== 骑行超速==================
    getOverSpeedType(t) {
      const map = {
        1: '持续超速'
      }
      return map[String(t)] || '-'
    },
    formatDuration(seconds) {
      if (seconds == null || isNaN(seconds)) return '0秒'
      const sec = parseInt(seconds)
      if (sec <= 0) return '0秒'
      // 计算各个时间单位
      const hours = Math.floor(sec / 3600)
      const minutes = Math.floor((sec % 3600) / 60)
      const remainingSeconds = sec % 60
      // 拼接时间字符串
      const parts = []
      if (hours > 0) parts.push(`${hours}小时`)
      if (minutes > 0) parts.push(`${minutes}分钟`)
      if (remainingSeconds > 0) parts.push(`${remainingSeconds}秒`)
      // 处理全零的特殊情况
      if (parts.length === 0) return '0秒'
      return parts.join('')
    },
    loadOverSpeedData() {
      const vm = this
      vm.overspeedLoading = true
      const params = {
        selfAreaId: vm.selfAreaId,
        currentPage: vm.overSpeedPage.pageNum,
        pageSize: vm.overSpeedPage.pageSize,
        brandId: vm.overspeedForm.brandId,
        bikeId: vm.overspeedForm.bikeId,
        orderNo: vm.overspeedForm.orderNo,
        userBikeType: vm.overspeedForm.bikeType
      }
      if (vm.overspeedForm.createTime && vm.overspeedForm.createTime[0] && vm.overspeedForm.createTime[1]) {
        params.startTime = dayjs(vm.overspeedForm.createTime[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        params.endTime = dayjs(vm.overspeedForm.createTime[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      Api.getOverSpeedAlarmList(params)
        .then(res => {
          if (res.code === 200) {
            vm.overSpeedData = res.data.lists
            vm.overSpeedTotal = res.data.total
          } else {
            vm.$message.warning(res.message)
          }
          vm.calcView()
          vm.overspeedLoading = false
        })
    },
    onOverSpeedSearch() {
      this.overSpeedPage.pageNum = 1
      this.loadOverSpeedData()
    },
    overSpeedPageNoChange(page) {
      this.overSpeedPage.pageNum = page
      this.loadOverSpeedData()
    },
    overSpeedHandleSizeChange(size) {
      this.overSpeedPage.pageSize = size
      this.loadOverSpeedData()
    },
    onOverSpeedReset() {
      this.overspeedForm = {
        brandId: '',
        bikeId: '',
        orderNo: '',
        createTime: [dateFormat(new Date().setDate(new Date().getDate()), 'yyyy-MM-dd'), dateFormat(new Date(), 'yyyy-MM-dd')],
        bikeType: '',
        disabled: true
      }
      this.onOverSpeedSearch()
    },
    onOverSpeedExport() {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId,
        currentPage: vm.overSpeedPage.pageNum,
        pageSize: vm.overSpeedPage.pageSize,
        brandId: vm.overspeedForm.brandId,
        bikeId: vm.overspeedForm.bikeId,
        orderNo: vm.overspeedForm.orderNo
      }
      if (vm.overspeedForm.createTime && vm.overspeedForm.createTime[0] && vm.overspeedForm.createTime[1]) {
        params.startTime = dayjs(vm.overspeedForm.createTime[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        params.endTime = dayjs(vm.overspeedForm.createTime[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      Api.exportOverSpeedAlarm(params)
        .then(res => {
          if (res.code === 200) {
            lookPDF(res.data)
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    getRideSpeedLimitConfig() {
      Api.getRideSpeedLimitConfig(this.selfAreaId)
        .then(res => {
          if (res.code === 200) {
            this.speedLimitData = res.data
            this.speedLimit = res.data !== null ? res.data.speedLimit : undefined
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    saveSpeedLimit() {
      if (this.speedLimit === undefined || this.speedLimit <= 0) {
        this.$message.warning('超速阈值必须大于 0')
        return
      }
      const params = {
        areaId: this.selfAreaId,
        speedLimit: this.speedLimit,
        ...(this.speedLimitData !== null && { id: this.speedLimitData.id, updateBy: this.user.id }), // 如果是修改操作，添加 updateBy
        ...(this.speedLimitData === null && { createBy: this.user.id })  // 如果是新增操作，添加 createBy
      }
      Api.setRideSpeedLimitConfig(this.selfAreaId, params)
        .then(res => {
          if (res.code === 200) {
            this.$message.success('保存成功')
          } else {
            this.$message.warning(res.message)
          }
        })
    }
  },
  components: {
    WTable
  }
}
</script>

<style scoped>
.mb3 {
  margin-bottom: 3px;
}

.warning-text p {
  font-size: 12px;
  color: #999;
}
.pink {
  color: #FF00FF;
}
.w120px {
  width: 120px;
}
.w200px {
  width: 200px;
}
.w250px {
  width: 250px;
}
.showWarningText {
  font-size: 15px;
  margin-left: 10px;
  color: #3e7878;
  cursor: pointer;
}
.setting-container {
  display: flex;
  align-items: center;
  padding: 8px 40px;
}
.setting-container label {
  font-size: 14px;
  color: #333;
  margin-right: 8px;
  white-space: nowrap;
}
.setting-container .el-input-number {
  width: 100px !important;
  margin-right: 6px;
}
.setting-container .time-unit {
  font-size: 14px;
  color: #666;
  margin-right: 10px;
}
</style>
<style lang="less">
  .warning-show {
    .el-form-item__label {
      cursor: pointer;
    }
  }
  .abh {
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .el-select-dropdown__wrap {
    max-height: 100% !important;
  }
  .table-container{
    background-color: white;
  }
</style>
